/*--- isotope Auto Height adjust ---*/
$(window).load(function() {

    var $container = $('.reviewsList ul'),
        filters = {};

    $container.isotope({
        itemSelector: '.isotopeItems',
        masonry: {
            columnWidth: 0,
            horizontalOrder: true,
        }
    });    
});


 /*--- isotope with Tabs Click ---*/
$(window).load(function() {

    var $container = $('#container'),
        filters = {};

    $container.isotope({
        itemSelector: '.isotopeItems',
        masonry: {
            columnWidth: 0,
        }
    });

    // filter buttons
    $('.filterItem a').click(function () {
        var $this = $(this);
        // don't proceed if already selected
        if ($this.hasClass('selected')) {
            return;
        }

        var $optionSet = $this.parents('.option-set');
        // change selected class
        $optionSet.find('.selected').removeClass('selected');
        $this.addClass('selected');

        // store filter value in object
        // i.e. filters.color = 'red'
        var group = $optionSet.attr('data-filter-group');
        filters[group] = $this.attr('data-filter-value');
        // convert object into array
        var isoFilters = [];
        for (var prop in filters) {
            isoFilters.push(filters[prop])
        }
        var selector = isoFilters.join('');
        $container.isotope({ filter: selector });

        return false;
    });

    $cls = $('#productFilter .filterList .productListItem li');

    var hasCls = $cls.hasClass('active');
    var child = "";
    if (hasCls) {
       child = $('#productFilter .filterList .productListItem li.active a').attr('data-filter-value');

    }

    var $containerProduct = $('#productcontainer');
    $containerProduct.isotope({
        itemSelector: '.isotopeItems',
        filter: child,
        masonry: {
            columnWidth: 0,
        }
    });
    
     $('#productFilter .Reset').on('click',function () {
        $('#productFilter .filterList .productListItem li').removeClass("active");
        $containerProduct.isotope({ filter:''});
     });
     
     $('#productFilter .filterList .productListItem li a').on('click',function () {
        var $this1 = $(this);
        $this1.parent('li').toggleClass("active");
        $optionSetActive =  $('#productFilter .filterList .productListItem');
        var selectedVal = [];
        $optionSetActive.each(function (k,l) { 
            var $this2 = $(l);
            $this2.find('li.active').each(function(m,n){
              $this3 =  $(n);
              var temps = $this3.find('a').attr('data-filter-value');
              selectedVal.push(temps);
            });
        });
        
        var selector = selectedVal.join(''); 
          //  var selector = '.retail .black';
           
            $containerProduct.isotope({ filter: selector });
         });        

});